import { IconProps } from '../IconsTypes'

const ArcaMarkerIcon = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="26"
      height="28"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.667 31.3332C0.000451326 23.3332 -5.99993 3.99984 14.667 0.666504C36.6665 5.33317 28.6669 23.3332 14.667 31.3332Z"
        fill="#FFD500"
      />
      <path
        d="M14.6667 0C6.57905 0 0 6.44103 0 14.359C0 22.7577 7.87305 27.8481 13.0827 31.2171L13.9693 31.7933C14.1805 31.9311 14.4236 32 14.6667 32C14.9097 32 15.1528 31.9311 15.364 31.7933L16.2507 31.2171C21.4603 27.8481 29.3333 22.7577 29.3333 14.359C29.3333 6.44103 22.7543 0 14.6667 0ZM14.8662 29.1627L14.6667 29.2925L14.4672 29.1627C9.42184 25.9003 2.51429 21.4334 2.51429 14.359C2.51429 7.79815 7.96526 2.46154 14.6667 2.46154C21.3681 2.46154 26.819 7.79815 26.819 14.359C26.819 21.4334 19.9098 25.9019 14.8662 29.1627Z"
        fill="black"
      />
      <path
        d="M17.1501 19.998C16.6439 19.998 16.4069 19.5556 16.3511 19.3217L16.1547 18.5082C16.1547 18.5082 16.1192 18.3912 16.0396 18.3912H13.2399C13.1721 18.3912 13.1484 18.4607 13.1417 18.4899L12.9673 19.3253C12.9199 19.5575 12.6965 19.998 12.1836 19.998H8.55778C8.2971 19.998 8.16337 19.881 8.09567 19.7823C7.94163 19.5575 8.0178 19.2686 8.02626 19.2357L11.8552 7.34651C11.9094 7.12167 12.1565 6.6665 12.6694 6.6665H16.5407C17.0586 6.6665 17.3092 7.10705 17.3701 7.34103L21.2905 19.2047C21.3006 19.2357 21.4022 19.5428 21.2515 19.7787C21.1872 19.8792 21.0552 19.9998 20.7911 19.9998H17.1517L17.1501 19.998ZM15.266 14.8906L14.6347 11.6807L14.0033 14.8906H15.266Z"
        fill="black"
      />
    </svg>
  )
}

export default ArcaMarkerIcon
